import { SearchInput } from "@molecules/index"

import useTable from "@organisms/Table/Table.context"

export default function TableKeywordSearch() {
    const { searchKeywords, setSearchKeywords } = useTable()

    return <SearchInput defaultValue={searchKeywords} onValueChange={setSearchKeywords} type="field" />
}
